import { m as motion } from "framer-motion";
import { FlaskConical } from "lucide-react";
import { UseCasesSection } from "@/components/use-cases-section";
import { CallToActionSection } from "@/components/call-to-action-section";
import { useSEO } from "@/lib/use-seo";
import { MEMBER_SHOWCASE_PATH } from "@/lib/routes";
import { breadcrumb } from "@/lib/seo-schemas";

const MemberShowcase = () => {
  useSEO({
    title: "Member Showcase: HR people who expanded what they can do",
    description:
      "See how Mastermind members took constraints off their HR work and expanded what they could take on. Real roles, anonymized builds, not theory.",
    path: MEMBER_SHOWCASE_PATH,
    ogImage: "/images/og-from-the-lab.jpg",
    jsonLd: breadcrumb([
      { name: "Home", path: "/" },
      { name: "Member Showcase", path: MEMBER_SHOWCASE_PATH },
    ]),
  });
  return (
    <div className="min-h-screen">
      {/* Hero */}
      <section className="relative overflow-hidden bg-gradient-mesh pt-24 md:pt-28 pb-8">
        <div className="section-inner relative z-10 text-center space-y-5">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 border border-primary/20"
          >
            <FlaskConical className="w-8 h-8 text-primary" />
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold gradient-text"
          >
            Member Showcase
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto"
          >
            Members who took the constraints off their work, then expanded what they could take on. Illustrated by what they built in the Mastermind.
          </motion.p>
        </div>
      </section>

      <UseCasesSection />

      {/* Disclaimer */}
      <section className="container-class">
        <div className="section-inner text-center">
          <p className="text-sm text-muted-foreground/60 italic max-w-3xl mx-auto">
            Examples are anonymized Mastermind builds. Your stack, policies, and data rules always come first.
          </p>
        </div>
      </section>

      <CallToActionSection />
    </div>
  );
};

export default MemberShowcase;
